module.exports = __webpack_public_path__ + "img/cartoon-home.544d6729.jpg";